import React from "react";
import { connect } from "react-redux";
import { Wrapper } from "./style.js";
import Printable from "../../../../components/Printable";
import _ from "lodash";
import { domains, domainKeys } from "../../../../modules/magnetDomains";
import Header from "../Header";
import SRHCopyright from "../../../../components/SRHCopyright";
import Grid from "@material-ui/core/Grid";
import clsx from "clsx";
import DataTableRow from "../DataTableRow";
import { getBenchmarkLabel } from "../../../../lib/utils";

function DataTable({magnetWorkSettings, magnetReport, ready, domainCombination, page, benchmarks}) {
  const mainBenchmark = Object.keys(benchmarks.data)[0];
  const pageOneSize = 16;
  const pageSize = 17;

  const getBenchmark = (key) => {
    return benchmarks.data[magnetReport.workSettingBenchmarks.split(',')[0]][key];
  }

  const getCount = (pageCount) => {
    if (pageCount === 0) {
      return 0;
    }
    if (pageCount === 1) {
      return pageOneSize;
    }
    if (pageCount > 1) {
      return pageOneSize + pageSize * (pageCount - 1);
    }
  }

  if (ready) {
    const selectedDomains = new Set();
    selectedDomains.add(domainCombination.domainOne);
    selectedDomains.add(domainCombination.domainTwo);
    selectedDomains.add(domainCombination.domainThree);
    selectedDomains.add(domainCombination.domainFour);
    const units = _.map(domainCombination.units, "name");
    const pages = [];
    while (getCount(pages.length) < units.length) {
      const pageStart = getCount(pages.length);
      const pageOfUnits = [];
      let thisPageSize = pageSize;
      if (pages.length < 1) {
        thisPageSize = pageOneSize;
      }
      for (let i = pageStart; i < thisPageSize + pageStart && i < units.length; i++) {
        pageOfUnits.push(units[i]);
      }
      pages.push(
        <Printable key={`page-${pages.length + 1}`} page={page + pages.length}>
          <Wrapper>
            {pages.length < 1 && <Header title={magnetReport.datasetName} />}
            <div className={clsx("data-table", { "extra-padding-top": pages.length > 0 })}>
              <Grid container spacing={2} className="row">
                <Grid item className="column work-setting-column" />
                {_.map(domains, domain => (
                  <Grid
                    item
                    key={domain.key}
                    className={clsx(
                      "column data-column",
                      `column-header ${selectedDomains.has(domain.key) ? "selected" : ""}`
                    )}
                  >
                    {domain.name}
                  </Grid>
                ))}
              </Grid>
              <Grid container spacing={2} className="row">
                <Grid item className="column work-setting-column">
                  {getBenchmarkLabel(mainBenchmark, pageOfUnits)}
                </Grid>
                {_.map(domainKeys, key => (
                  <Grid
                    item
                    key={key}
                    className={clsx("column data-column", selectedDomains.has(key) ? "selected" : "")}
                  >
                    {getBenchmark(key)}%
                  </Grid>
                ))}
              </Grid>
              {_.map(pageOfUnits, (unit, index) => 
                <DataTableRow 
                  key={`${unit}-${index}`} 
                  unit={unit} 
                  magnetWorkSettings={magnetWorkSettings} 
                  selectedDomains={selectedDomains}
                  magnetReport={magnetReport}
                />
              )}
            </div>
          </Wrapper>
          <SRHCopyright />
        </Printable>
      );
    }
    return pages;
  } else {
    return <Printable />;
  }
}

export default connect(store => {
  return {
    magnetReport: store.magnetReport.magnetReport,
    magnetWorkSettings: store.magnetWorkSettings.magnetWorkSettings,
    benchmarks: store.benchmarks,
  };
})(DataTable);



// WEBPACK FOOTER //
// ./src/pages/MagnetReport/components/DataTable/index.jsx